<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item label="实例">
          <el-select v-model="instanceCode" placeholder="请选择实例" @change="loadData">
            <el-option
              v-for="item in instances"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="port" placeholder="请输入端口"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="success" @click="addFirewall">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table
      :data="tableData"
      style="width: 100%"
      row-key="id"
      border
      lazy
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="protocol" label="协议" width="100"></el-table-column>
      <el-table-column prop="port" label="端口" width="100"></el-table-column>
      <el-table-column prop="cidrBlock" label="来源" width="100"></el-table-column>
      <el-table-column prop="firewallRuleDescription" label="描述" width="200"></el-table-column>
    </el-table>

  </div>
</template>

<script>
import {tencentApi} from '../../api/index';
import {HttpResp} from '../../constant/index';

export default {
  name: 'ScheduleTaskList',
  data() {
    return {
      tableData: [],
      port: '',
      instanceCode: '',
      instances: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
    }
  },
  mounted: function () {
    this.listInstance();
  },
  computed: {

  },
  methods: {
    loadData() {
      tencentApi.listFirewall(this.instanceCode).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.tableData = data.data;
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    addFirewall() {
      tencentApi.addFirewall(this.port, this.instanceCode).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.$message({
            type: 'success',
            message: "增加成功"
          });
          this.loadData();
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    listInstance() {
      tencentApi.listInstance().then(data => {
        if (data.code == HttpResp.SUCCUSS) {
          this.instances = data.data;
          if (this.instances.length > 0) {
            this.instanceCode = this.instances[0].code;
            this.loadData();
          }
        } else {
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/components/tencent/TencentFirewall.vue